module.exports = __webpack_public_path__ + "static/media/folder_color-1.860203f5.svg";